// extracted by mini-css-extract-plugin
export var brand = "_bv-9";
export var compact = "_bv-6";
export var extraSmall = "_bv-7";
export var icon = "_bv-0";
export var large = "_bv-4";
export var light = "_bv-1";
export var medium = "_bv-5";
export var outline = "_bv-b";
export var primaryDark = "_bv-a";
export var primaryLight = "_bv-8";
export var primaryModern = "_bv-c";
export var success = "_bv-2";
export var successSolid = "_bv-3";